





























import {
  Vue, Prop, Component,
} from 'vue-property-decorator';
import { VbDirectives } from '@/shared/directive/vb-directives';

@Component({
  filters: {
    toCurrency: VbDirectives.toCurrency,
  },
})
export default class OverviewCardExpandableRow extends Vue {
  @Prop({
    required: true,
  })
  private headers!: object[];
}
